import { MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../../constants';
import {
  ReflectionTopicsDrawerControlsWrapper as BaseReflectionTopicsDrawerControlButton,
  ReflectionTopicsDrawerControlMenuItemWrapper as BaseReflectionTopicsDrawerControlMenuItem,
} from '../../reflections/ReflectionTopicsDrawerControls';

export function VisitorMeetingReflectionTopicsDrawerControlButton({ className }: { className?: string }) {
  return (
    <BaseReflectionTopicsDrawerControlButton
      className={className}
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}

export function VisitorMeetingReflectionTopicsDrawerControlMenuItem({ className }: { className?: string }) {
  return (
    <BaseReflectionTopicsDrawerControlMenuItem
      className={className}
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}
